import React from 'react';
import AriesIcon from './AriesIcon';
import TaurusIcon from './TaurusIcon';
import GeminiIcon from './GeminiIcon';
import CancerIcon from './CancerIcon';
import LeoIcon from './LeoIcon';
import VirgoIcon from './VirgoIcon';
import LibraIcon from './LibraIcon';
import ScorpioIcon from './ScorpioIcon';
import SagittariusIcon from './SagittariusIcon';
import CapricornIcon from './CapricornIcon';
import AquariusIcon from './AquariusIcon';
import PiscesIcon from './PiscesIcon';

const ConstellationIcon = ({ name, ...props }) => {
  switch (name.toLowerCase()) {
    case 'aries':
      return <AriesIcon {...props} />;
    case 'taurus':
      return <TaurusIcon {...props} />;
    case 'gemini':
      return <GeminiIcon {...props} />;
    case 'cancer':
      return <CancerIcon {...props} />;
    case 'leo':
      return <LeoIcon {...props} />;
    case 'virgo':
      return <VirgoIcon {...props} />;
    case 'libra':
      return <LibraIcon {...props} />;
    case 'scorpio':
      return <ScorpioIcon {...props} />;
    case 'sagittarius':
      return <SagittariusIcon {...props} />;
    case 'capricorn':
      return <CapricornIcon {...props} />;
    case 'aquarius':
      return <AquariusIcon {...props} />;
    case 'pisces':
      return <PiscesIcon {...props} />;
    default:
      return <div style={{ width: props.width || 80, height: props.height || 80, backgroundColor: '#333', borderRadius: '50%' }} />;
  }
};

export default ConstellationIcon;
